import { B400 } from '@atlaskit/theme/colors';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { SecondaryProductSelectButtonPropsType } from '../../model';
import { messages } from '../messages';
import { CharlieDisplayFontStack } from '../styled';

export function SecondaryProductSelectButton({
  isSelected,
  handleClick,
  btnId
}: SecondaryProductSelectButtonPropsType) {
  const buttonText = isSelected
    ? messages.removeButtonLabel
    : messages.selectButtonLabel;
  return (
    <SecondaryProductButton
      data-testid={`select-btn-${btnId}`}
      onClick={() => handleClick()}
    >
      <FormattedMessage {...buttonText} />
    </SecondaryProductButton>
  );
}

export const SecondaryProductButton = styled.button`
  font-family: ${CharlieDisplayFontStack};
  font-style: normal;
  display: flex;
  align-item: center;
  justify-content: center;
  background-color: white !important;
  color: ${B400} !important;
  border: 1px solid ${B400} !important;
  margin-bottom: 0;
  font-weight: 500;
  min-height: 40px;
  padding: 0 16px;
  border-radius: 3px;
  transition: all 250ms;
  width: 100% !important;
  font-size: 100%;
  line-height: 38px;

  &:hover {
    background-color: ${B400} !important;
    color: white !important;
    cursor: pointer;
  }
`;
